module.exports = __webpack_public_path__ + "img/zx_zhu1.9c38cc18.png";